module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "linha-do-tempo"
  }, [_c('div', {
    staticClass: "linha-do-tempo__cabecalho"
  }, [_c('h2', {
    staticClass: "titulo titulo_pequeno"
  }, [_vm._v("\n      " + _vm._s(_vm.titulo) + " · " + _vm._s(_vm.itens.length) + "\n      " + _vm._s(_vm.itens.length === 1 ? _vm.rotuloSingular : _vm.rotuloPlural) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-cinza botao_sem-preenchimento botao_medio",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.alternarExpandirTudo
    }
  }, [_vm._v("\n      " + _vm._s(_vm.todosExpandidos ? 'Recolher tudo' : 'Expandir tudo') + "\n    ")])]), _vm._v(" "), (_vm.itens.length) ? _c('div', {
    staticClass: "linha-do-tempo__lista"
  }, _vm._l((_vm.itens), function(item, index) {
    return _c('div', {
      key: item.id != null ? item.id : index,
      staticClass: "linha-do-tempo__item"
    }, [_c('span', {
      staticClass: "linha-do-tempo__marcador",
      class: 'linha-do-tempo__marcador_' + (item.corDoMarcador || 'sucesso'),
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('i', {
      class: item.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "linha-do-tempo__card",
      class: {
        'linha-do-tempo__card_vinho': item.varianteDoPrazo === 'vencido',
        'linha-do-tempo__card_info': item.varianteDoPrazo === 'prorrogado',
      }
    }, [_c('button', {
      staticClass: "linha-do-tempo__cabecalho-item",
      attrs: {
        "type": "button",
        "aria-expanded": _vm.itemEstaExpandido(index)
      },
      on: {
        "click": function($event) {
          return _vm.alternarItem(index)
        }
      }
    }, [(item.titulo) ? _c('span', {
      class: [
        'tags',
        item.corDaTag || 'tags_cor-azul',
        {
          tags_grande: _vm.tagsGrandes
        } ]
    }, [_vm._v("\n            " + _vm._s(item.titulo) + "\n          ")]) : _vm._e(), _vm._v(" "), (item.setorResponsavelAtual) ? [_c('span', {
      staticClass: "linha-do-tempo__separador-setor",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      class: ['tags', 'tags_cor-cinza', {
        tags_grande: _vm.tagsGrandes
      }]
    }, [_vm._v("\n              " + _vm._s(item.setorResponsavelAtual) + "\n            ")])] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "linha-do-tempo__lado-direito"
    }, [_c('span', {
      staticClass: "texto texto_medio texto_cor-cinza-50"
    }, [_vm._v("\n              " + _vm._s(item.data) + "\n            ")]), _vm._v(" "), _c('i', {
      staticClass: "far linha-do-tempo__chevron",
      class: _vm.itemEstaExpandido(index) ? 'fa-chevron-up' : 'fa-chevron-down',
      attrs: {
        "aria-hidden": "true"
      }
    })])], 2), _vm._v(" "), (_vm.itemEstaExpandido(index)) ? _c('div', {
      staticClass: "linha-do-tempo__detalhes"
    }, [_c('hr', {
      staticClass: "linha-do-tempo__divisor"
    }), _vm._v(" "), (item.mensagem) ? _c('span', {
      staticClass: "texto texto_medio texto_cor-cinza-90"
    }, [_vm._v(_vm._s(item.mensagem))]) : _vm._e(), _vm._v(" "), (item.observacao) ? _c('div', {
      staticClass: "linha-do-tempo__observacao"
    }, [_c('span', {
      staticClass: "linha-do-tempo__observacao-titulo"
    }, [_vm._v("\n              " + _vm._s(item.tituloDaObservacao || 'Observação') + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "linha-do-tempo__observacao-texto"
    }, [_vm._v("\n              " + _vm._s(item.observacao) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "linha-do-tempo__rodape"
    }, [(item.responsavel) ? _c('span', {
      staticClass: "linha-do-tempo__responsavel texto texto_pequeno texto_cor-cinza-90"
    }, [_vm._v("\n              Por\n              "), _c('span', {
      staticClass: "linha-do-tempo__responsavel-nome"
    }, [_vm._v(_vm._s(item.responsavel))])]) : _c('span'), _vm._v(" "), (item.setorOrigem || item.setorDestino) ? _c('span', {
      staticClass: "linha-do-tempo__setor"
    }, [(item.setorOrigem) ? [_c('span', {
      class: ['tags', 'tags_cor-cinza', {
        tags_grande: _vm.tagsGrandes
      }]
    }, [_vm._v(_vm._s(item.setorOrigem))]), _vm._v(" "), _c('i', {
      staticClass: "far fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })] : _vm._e(), _vm._v(" "), (item.setorDestino) ? _c('span', {
      class: ['tags', 'tags_cor-cinza', {
        tags_grande: _vm.tagsGrandes
      }]
    }, [_vm._v("\n                " + _vm._s(item.setorDestino) + "\n              ")]) : _vm._e()], 2) : _vm._e()])]) : _vm._e()])])
  }), 0) : _c('p', {
    staticClass: "linha-do-tempo__vazio"
  }, [_vm._v("\n    " + _vm._s(_vm.mensagemVazio) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fef8da04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LinhaDoTempo.vue
// module id = 1145
// module chunks = 1